// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

// Eager load all controllers defined in the import map under controllers/**/*_controller
// import { eagerLoadControllersFrom } from "@hotwired/stimulus-webpack-helpers";
// eagerLoadControllersFrom("controllers", application);

// Lazy load controllers as they appear in the DOM (remember not to preload controllers in import map!)
// import { lazyLoadControllersFrom } from "@hotwired/stimulus-loading"
// lazyLoadControllersFrom("controllers", application)

import DisableModalController from './disable_modal_controller'
application.register('disable-modal', DisableModalController)

import MaytapiFailoverController from './maytapi_failover_controller'
application.register('maytapi-failover', MaytapiFailoverController)

import MaytapiNumberController from './maytapi_number_controller'
application.register('maytapi-number', MaytapiNumberController)

import ApexBarController from './apex_bar_controller'
application.register('apex-bar', ApexBarController)

import ApexHorizontalBarController from './apex_horizontal_bar_controller'
application.register('apex-bar-horizontal', ApexHorizontalBarController)

import ApexStackedBarController from './apex_stacked_bar_controller'
application.register('apex-stacked-bar', ApexStackedBarController)

import TicketsTimelineChartController from './tickets_timeline_chart_controller'
application.register('tickets-timeline-chart', TicketsTimelineChartController)

import AtendimentosBarController from './atendimentos_bar_controller'
application.register('atendimentos-bar', AtendimentosBarController)

import AtendimentosStackedBarController from './atendimentos_stacked_bar_controller'
application.register('atendimentos-stacked-bar', AtendimentosStackedBarController)

import ApexPieController from './apex_pie_controller'
application.register('apex-pie', ApexPieController)

import ApexDonutController from './apex_donut_controller'
application.register('apex-donut', ApexDonutController)

import ApexLineController from './apex_line_controller'
application.register('apex-line', ApexLineController)

import RadialBarController from './radial_bar_controller'
application.register('radial-bar', RadialBarController)

import FlatpickrController from './flatpickr_controller'
application.register('flatpickr', FlatpickrController)

import FunnelController from './funnel_contoller'
application.register('funnel', FunnelController)

import WordCloudController from './word_cloud_controller'
application.register('word-cloud', WordCloudController)

import ListingModalController from './listing_modal_controller'
application.register('listing-modal', ListingModalController)

import MassiveEngagementController from './massive_engagement_controller'
application.register('massive-engagement', MassiveEngagementController)

import MassiveEngagementTemplateSelectorController from './massive_engagement_template_selector_controller'
application.register(
  'massive-engagement-template-selector',
  MassiveEngagementTemplateSelectorController
)

import MonthFilterController from './month_filter_controller'
application.register('month-filter', MonthFilterController)

import ModalTransitionController from './modal_transition_controller'
application.register('modal-transition', ModalTransitionController)

import ModalController from './modal_controller'
application.register('modal', ModalController)

import ModalOpenerController from './modal_opener_controller'
application.register('modal-opener', ModalOpenerController)

import TemplateSelectorController from './template_selector_controller'
application.register('template-selector', TemplateSelectorController)

import TemplateParametersController from './template_parameters_controller'
application.register('template-parameters', TemplateParametersController)

import TemplatePreviewController from './template_preview_controller'
application.register('template-preview', TemplatePreviewController)

import CollapsibleController from './collapsible_controller'
application.register('collapsible', CollapsibleController)

import RowExpandController from './row_expand_controller'
application.register('row-expand', RowExpandController)

import CollapsibleFiltersController from './collapsible_filters_controller'
application.register('collapsible-filters', CollapsibleFiltersController)

import AudioController from './audio_controller'
application.register('audio', AudioController)

import AudioModalController from './audio_modal_controller'
application.register('audio-modal', AudioModalController)

import UserEditModalController from './user_edit_modal_controller'
application.register('user-edit-modal', UserEditModalController)

import UserCreateModalController from './user_create_modal_controller'
application.register('user-create-modal', UserCreateModalController)

import CarouselController from './carousel_controller'
application.register('carousel', CarouselController)

import SnapCarouselController from './snap_carousel_controller'
application.register('snap-carousel', SnapCarouselController)

import NotificationCentreController from './notification_centre_controller'
application.register('notification-centre', NotificationCentreController)

import PlatformTestingController from './platform_testing_controller'
application.register('platform-testing', PlatformTestingController)

import CrmIntegrationDetectionController from './crm_integration_detection_controller'
application.register('crm-integration-detection', CrmIntegrationDetectionController)

import DataRetrieverTestingController from './data_retriever_testing_controller'
application.register('data-retriever-testing', DataRetrieverTestingController)

import TagCreationController from './tag_creation_controller'
application.register('tag-creation', TagCreationController)

import TagCollapsibleController from './tag_collapsible_controller'
application.register('tag-collapsible', TagCollapsibleController)

import RoletaCreationController from './roleta_creation_controller'
application.register('roleta-creation', RoletaCreationController)

import RoletaCollapsibleController from './roleta_collapsible_controller'
application.register('roleta-collapsible', RoletaCollapsibleController)

import RotationManagementController from './rotation_management_controller'
application.register('rotation-management', RotationManagementController)

import InlineEditController from './inline_edit_controller'
application.register('inline-edit', InlineEditController)

import DraftCleanupController from './draft_cleanup_controller'
application.register('draft-cleanup', DraftCleanupController)

import SectionMemoryController from './section_memory_controller'
application.register('section-memory', SectionMemoryController)

import RelocationOfferController from './relocation_offer_controller'
application.register('relocation-offer', RelocationOfferController)

import RotationCrudController from './rotation_crud_controller'
application.register('rotation-crud', RotationCrudController)

import RotationConditionsController from './rotation_conditions_controller'
application.register('rotation-conditions', RotationConditionsController)

import EngagementPresetController from './engagement_preset_controller'
application.register('engagement-preset', EngagementPresetController)

import EngagementPipelineBuilderController from './engagement_pipeline_builder_controller'
application.register('engagement-pipeline-builder', EngagementPipelineBuilderController)

import EngagementPipelineScheduleController from './engagement_pipeline_schedule_controller'
application.register('engagement-pipeline-schedule', EngagementPipelineScheduleController)

import EngagementPipelineRateController from './engagement_pipeline_rate_controller'
application.register('engagement-pipeline-rate', EngagementPipelineRateController)

import EngagementPipelineTemplateController from './engagement_pipeline_template_controller'
application.register('engagement-pipeline-template', EngagementPipelineTemplateController)

import EngagementPipelineStepController from './engagement_pipeline_step_controller'
application.register('engagement-pipeline-step', EngagementPipelineStepController)

import RoutingConfigCardController from './routing_config_card_controller'
application.register('routing-config-card', RoutingConfigCardController)

import RoutingConfigRowController from './routing_config_row_controller'
application.register('routing-config-row', RoutingConfigRowController)

import RotationHistoryModalController from './rotation_history_modal_controller'
application.register('rotation-history-modal', RotationHistoryModalController)

import SortableController from './sortable_controller'
application.register('sortable', SortableController)

import ConfigurationSortableController from './configuration_sortable_controller'
application.register('configuration-sortable', ConfigurationSortableController)

import ContactFormToggleController from './contact_form_toggle_controller'
application.register('contact-form-toggle', ContactFormToggleController)

import CreditAnalysisController from './credit_analysis_controller'
application.register('credit-analysis', CreditAnalysisController)

import CsrfController from './csrf_controller'
application.register('csrf', CsrfController)

import DropdownController from './dropdown_controller'
application.register('dropdown', DropdownController)

import ChatManagerController from './chat_manager_controller'
application.register('chat-manager', ChatManagerController)

import MediaItemsController from './media_items_controller'
application.register('media-items', MediaItemsController)

import ToggleFormController from './toggle_form_controller'
application.register('toggle-form', ToggleFormController)

import ErpSpecificFieldsController from './erp_specific_fields_controller'
application.register('erp-specific-fields', ErpSpecificFieldsController)

import PermissionsController from './permissions_controller'
application.register('permissions', PermissionsController)

import ClientAssignmentsController from './client_assignments_controller'
application.register('client-assignments', ClientAssignmentsController)

import ClientAssignmentsImportController from './client_assignments_import_controller'
application.register('client-assignments-import', ClientAssignmentsImportController)

import TemplateCreatorController from './template_creator_controller'
application.register('template-creator', TemplateCreatorController)

import TemplateButtonsController from './template_buttons_controller'
application.register('template-buttons', TemplateButtonsController)

import TextExpanderController from './text_expander_controller'
application.register('text-expander', TextExpanderController)

import ClearFieldsController from './clear_fields_controller'
application.register('clear-fields', ClearFieldsController)

import RoutingBlockModeController from './routing_block_mode_controller'
application.register('routing-block-mode', RoutingBlockModeController)

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import ConfigurationConditionsController from './configuration_conditions_controller'
application.register('configuration-conditions', ConfigurationConditionsController)

import ConfigurationPriorityController from './configuration_priority_controller'
application.register('configuration-priority', ConfigurationPriorityController)

import ConfigurationTabsController from './configuration_tabs_controller'
application.register('configuration-tabs', ConfigurationTabsController)

import TemplateValidationController from './template_validation_controller'
application.register('template-validation', TemplateValidationController)

import UtilityReviewController from './utility_review_controller'
application.register('utility-review', UtilityReviewController)

import LibraryAdderController from './library_adder_controller'
application.register('library-adder', LibraryAdderController)

import AgentSelectionController from './agent_selection_controller'
application.register('agent-selection', AgentSelectionController)

import TemplateEditorController from './template_editor_controller'
application.register('template-editor', TemplateEditorController)

import TemplateFoldersController from './template_folders_controller'
application.register('template-folders', TemplateFoldersController)

import FolderSelectController from './folder_select_controller'
application.register('folder-select', FolderSelectController)

import FormLoadingController from './form_loading_controller'
application.register('form-loading', FormLoadingController)

import TenantsController from './tenants_controller'
application.register('tenants', TenantsController)

import AiSummaryPollingController from './ai_summary_polling_controller'
application.register('ai-summary-polling', AiSummaryPollingController)

import FolderUploadController from './folder_upload_controller'
application.register('folder-upload', FolderUploadController)

import SyncFromMetaController from './sync_from_meta_controller'
application.register('sync-from-meta', SyncFromMetaController)

import RotationAssignmentController from './rotation_assignment_controller'
application.register('rotation-assignment', RotationAssignmentController)

import ToggleSwitchController from './toggle_switch_controller'
application.register('toggle-switch', ToggleSwitchController)

import SoundPreviewController from './sound_preview_controller'
application.register('sound-preview', SoundPreviewController)

import RotationPriorityController from './rotation_priority_controller'
application.register('rotation-priority', RotationPriorityController)

import RotationEnabledController from './rotation_enabled_controller'
application.register('rotation-enabled', RotationEnabledController)

import LeadTransformerConditionController from './lead_transformer_condition_controller'
application.register('lead-transformer-condition', LeadTransformerConditionController)

import LeadTransformerFormController from './lead_transformer_form_controller'
application.register('lead-transformer-form', LeadTransformerFormController)

import SupportTransformerFormController from './support_transformer_form_controller'
application.register('support-transformer-form', SupportTransformerFormController)
import NestedFormController from './nested_form_controller'
application.register('nested-form', NestedFormController)

import TransformerPriorityController from './transformer_priority_controller'
application.register('transformer-priority', TransformerPriorityController)

import HeartbeatController from './heartbeat_controller'
application.register('heartbeat', HeartbeatController)

import UserStatusController from './user_status_controller'
application.register('user-status', UserStatusController)

import ProfileEditController from './profile_edit_controller'
application.register('profile-edit', ProfileEditController)

import WebPushController from './web_push_controller'
application.register('web-push', WebPushController)

import WorkScheduleManagementController from './work_schedule_management_controller'
application.register('work-schedule-management', WorkScheduleManagementController)

import TabsController from './tabs_controller'
application.register('tabs', TabsController)

import CollapsibleSectionController from './collapsible_section_controller'
application.register('collapsible-section', CollapsibleSectionController)

import ResponseTimelineController from './response_timeline_controller'
application.register('response-timeline', ResponseTimelineController)

import ReadMoreController from './read_more_controller'
application.register('read-more', ReadMoreController)

import TableRowController from './table_row_controller'
application.register('table-row', TableRowController)

import ComboboxController from './combobox_controller'
application.register('combobox', ComboboxController)

import ReactRenderController from './react_render_controller'
application.register('react-render', ReactRenderController)

import SkeletonController from './skeleton_controller'
application.register('skeleton', SkeletonController)

import SurveyTypeFormController from './survey_type_form_controller'
application.register('survey-type-form', SurveyTypeFormController)

import SurveyConditionalAnswerController from './survey_conditional_answer_controller'
application.register('survey-conditional-answer', SurveyConditionalAnswerController)

import NpsDistributionController from './nps_distribution_controller'
application.register('nps-distribution', NpsDistributionController)

import UserSearchController from './user_search_controller'
application.register('user-search', UserSearchController)

import DevelopmentUnitsController from './development_units_controller'
application.register('development-units', DevelopmentUnitsController)

import AutoSubmitController from './auto_submit_controller'
application.register('auto-submit', AutoSubmitController)

import FaqContextController from './faq_context_controller'
application.register('faq-context', FaqContextController)

import UserMonitoringSearchController from './user_monitoring_search_controller'
application.register('user-monitoring-search', UserMonitoringSearchController)

import UserMonitoringTableSearchController from './user_monitoring_table_search_controller'
application.register('user-monitoring-table-search', UserMonitoringTableSearchController)

import UserMonitoringFiltersController from './user_monitoring_filters_controller'
application.register('user-monitoring-filters', UserMonitoringFiltersController)

import UserMonitoringDetailController from './user_monitoring_detail_controller'
application.register('user-monitoring-detail', UserMonitoringDetailController)

import BillingBlockingRulesController from './billing_blocking_rules_controller'
application.register('billing-blocking-rules', BillingBlockingRulesController)

import BillingPlanController from './billing_plan_controller'
application.register('billing-plan', BillingPlanController)

import GroupsController from './groups_controller'
application.register('groups', GroupsController)

import SubgroupRestrictionController from './subgroup_restriction_controller'
application.register('subgroup-restriction', SubgroupRestrictionController)

import SubcategoryModalController from './subcategory_modal_controller'
application.register('subcategory-modal', SubcategoryModalController)

import PendingQueueModalController from './pending_queue_modal_controller'
application.register('pending-queue-modal', PendingQueueModalController)


import PanelPreviewController from './panel_preview_controller'
application.register('panel-preview', PanelPreviewController)

import GroupTicketsController from './group_tickets_controller'
application.register('group-tickets', GroupTicketsController)

import TicketsResultsDrilldownController from './tickets_results_drilldown_controller'
application.register('tickets-results-drilldown', TicketsResultsDrilldownController)

import OpenTabController from './open_tab_controller'
application.register('open-tab', OpenTabController)

import FineTuningExampleController from './fine_tuning_example_controller'
application.register('fine-tuning-example', FineTuningExampleController)

import FtComposeController from './ft_compose_controller'
application.register('ft-compose', FtComposeController)

import FtCandidatesController from './ft_candidates_controller'
application.register('ft-candidates', FtCandidatesController)

import FtLaunchController from './ft_launch_controller'
application.register('ft-launch', FtLaunchController)

import ExcludeFromTrainingController from './exclude_from_training_controller'
application.register('exclude-from-training', ExcludeFromTrainingController)

import ReplayController from './replay_controller'
application.register('replay', ReplayController)

import LazyPanelController from './lazy_panel_controller'
application.register('lazy-panel', LazyPanelController)

import UnavailabilityWindowsController from './unavailability_windows_controller'
application.register('unavailability-windows', UnavailabilityWindowsController)

import KebabMenuController from './kebab_menu_controller'
application.register('kebab-menu', KebabMenuController)

import TextClampController from './text_clamp_controller'
application.register('text-clamp', TextClampController)

import SlideOverController from './slide_over_controller'
application.register('slide-over', SlideOverController)

import LeadPanelController from './lead_panel_controller'
application.register('lead-panel', LeadPanelController)

import KanbanScrollController from './kanban_scroll_controller'
application.register('kanban-scroll', KanbanScrollController)

import OperationHubCardsController from './operation_hub_cards_controller'
application.register('operation-hub-cards', OperationHubCardsController)

import TableSearchController from './table_search_controller'
application.register('table-search', TableSearchController)

import TitleSimulatorController from './title_simulator_controller'
application.register('title-simulator', TitleSimulatorController)

import DialogController from './dialog_controller'
application.register('dialog', DialogController)

import PlazaModalController from './plaza_modal_controller'
application.register('plaza-modal', PlazaModalController)

import ListingsSearchController from './listings_search_controller'
application.register('listings-search', ListingsSearchController)

import LeadBrokerResolverController from './lead_broker_resolver_controller'
application.register('lead-broker-resolver', LeadBrokerResolverController)

import ConversationStyleController from './conversation_style_controller'
application.register('conversation-style', ConversationStyleController)

import DaySelectorController from './day_selector_controller'
application.register('day-selector', DaySelectorController)
